<template>
  <transition name="NavMobile">
    <div class="NavMobile">
      <div class="NavMobile__top">
        <div>
          <div @click="$store.commit('app/SET_SUBTITLE', !subtitle)">
            <svg viewBox="0 0 29.74 26.73" v-if="!subtitle">
              <path class="cls-1" d="M19.79,1a9,9,0,0,1,9,8.94v6.44a9.36,9.36,0,0,1-9.35,9.35H9.94A9,9,0,0,1,1,16.79V9.94A9,9,0,0,1,9.94,1h9.85m0-1H9.94A9.94,9.94,0,0,0,0,9.94v6.85a9.94,9.94,0,0,0,9.94,9.94h9.45A10.35,10.35,0,0,0,29.74,16.38V9.94A10,10,0,0,0,19.79,0Z"/>
              <path class="cls-1" d="M7.06,13.37c0-3,1.3-5,3.84-5,2.3,0,3.26,1.51,3.4,3.35H12.42c-.11-1-.64-1.67-1.51-1.67h0c-1.18,0-1.94,1.25-1.94,3.35s.76,3.34,1.94,3.34h0c.87,0,1.37-.63,1.51-1.67H14.3c-.14,1.91-1.1,3.35-3.4,3.35C8.36,18.39,7.06,16.36,7.06,13.37Z"/>
              <path class="cls-1" d="M15.43,13.37c0-3,1.3-5,3.84-5,2.3,0,3.27,1.51,3.4,3.35H20.79c-.11-1-.64-1.67-1.5-1.67h0c-1.19,0-1.94,1.25-1.94,3.35s.75,3.34,1.94,3.34h0c.86,0,1.36-.63,1.5-1.67h1.88c-.13,1.91-1.1,3.35-3.4,3.35C16.73,18.39,15.43,16.36,15.43,13.37Z"/>
            </svg>
            <svg viewBox="0 0 29.73 26.73" v-if="subtitle">
              <rect class="cls-1" width="29.73" height="26.73" rx="10.35" ry="10.35"/>
              <path class="cls-2" d="M7.06,13.37c0-3,1.3-5,3.84-5,2.3,0,3.26,1.51,3.4,3.35H12.42c-.11-1-.64-1.67-1.51-1.67h0c-1.18,0-1.94,1.25-1.94,3.35s.76,3.34,1.94,3.34h0c.87,0,1.37-.63,1.51-1.67H14.3c-.14,1.91-1.1,3.35-3.4,3.35C8.36,18.39,7.06,16.36,7.06,13.37Z"/>
              <path class="cls-2" d="M15.43,13.37c0-3,1.3-5,3.84-5,2.3,0,3.27,1.51,3.4,3.35H20.79c-.11-1-.64-1.67-1.5-1.67h0c-1.19,0-1.94,1.25-1.94,3.35s.75,3.34,1.94,3.34h0c.86,0,1.36-.63,1.5-1.67h1.88c-.13,1.91-1.1,3.35-3.4,3.35C16.73,18.39,15.43,16.36,15.43,13.37Z"/>
            </svg>
          </div>
          <div class="NavMobile__lang" @click="$root.langSwitch()" v-html="lang == 'fr' ? 'EN' : 'FR'" />
        </div>
        <div>
          <div class="NavMobile__share" @click="$parent.share('facebook')">
            <svg viewBox="0 0 20.934 20.934">
              <path class="cls-1" d="M19.771,0H1.163A1.163,1.163,0,0,0,0,1.163V19.771a1.163,1.163,0,0,0,1.163,1.163H11.182V12.839H8.464V9.67h2.718V7.344a3.808,3.808,0,0,1,4.07-4.175,22.521,22.521,0,0,1,2.436.125V6.106H16.014c-1.308,0-1.561.622-1.561,1.538V9.661H17.59l-.407,3.169h-2.73v8.1h5.318a1.163,1.163,0,0,0,1.163-1.163V1.163A1.163,1.163,0,0,0,19.771,0Z" />
            </svg>
          </div>
          <div class="NavMobile__share" @click="$parent.share('twitter')">
            <svg viewBox="0 0 24.284 19.851">
              <path d="M0,17.534A14.164,14.164,0,0,0,21.8,4.95a10.036,10.036,0,0,0,2.48-2.572,9.856,9.856,0,0,1-2.851.775A4.929,4.929,0,0,0,23.617.394a10.165,10.165,0,0,1-3.1,1.224,4.99,4.99,0,0,0-8.554,4.618A14.243,14.243,0,0,1,1.689.952,4.975,4.975,0,0,0,3.239,7.6a5.053,5.053,0,0,1-2.263-.62,4.975,4.975,0,0,0,4,4.944,4.96,4.96,0,0,1-2.247.093,4.974,4.974,0,0,0,4.649,3.456A10.011,10.011,0,0,1,0,17.534Z" transform="translate(0 0.069)"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="NavMobile__content">
        <router-link :to="{ name: 'about.' + lang, params: { chapter: $route.params.chapter } }" class="NavMobile__link">{{ pages.about.admin[lang].title }}</router-link>
        <router-link
          class="NavMobile__link"
          v-for="chapter in chapters"
          :key="chapter.id"
          :style="{ backgroundImage: getGradient(chapter) }"
          :to="{ name: 'chapters.' + lang, params: { chapter: chapter[lang].slug } }">
          <div v-if="chapter.index !== 0" class="NavMobile__title is-1">{{ trans('Global.chapter') }} {{ chapter.index }}</div>
          <div class="NavMobile__title is-2">{{ chapter[lang].title }}</div>
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NavMobile',
  computed: {
    subtitle() { return this.$store.getters['app/subtitle'] },
    pages() { return this.$store.getters['data/pages'] },
  },
  methods: {
    getGradient(chapter) {
      return `linear-gradient(to right, ${chapter.colors.primary}, ${chapter.colors.secondary})`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.NavMobile
  position absolute
  top 0px
  left 0px
  right 0px
  height 100%
  overflow-y auto
  transition opacity .5s
  -webkit-overflow-scrolling touch
  &-enter
  &-leave-active
    opacity 0

  &__title
    &.is-1
      font-weight 100
    &.is-2
      font-weight 700
      margin-top 5px

  &__link
    background #9e3bf6
    padding 30px
    display block
    text-decoration none

  &__lang
    position relative
    top 3px

  &__share
    height 20px
    width 20px
    display block
    margin-right 20px
    cursor pointer

  &__top
    display flex
    padding 23px 45px 25px 20px
    background-image linear-gradient(90deg,#9e3bf6,#352fdc)
    justify-content space-between
    svg
      fill white
      .cls-1
        fill #fff
      .cls-2
        fill #552084
    > div
      display flex
      > div
      > a
        height 20px
        width 20px
        display block
        margin-right 20px

</style>
